// extracted by mini-css-extract-plugin
export default {"header":"BasicHeader_header__doJca","logo":"BasicHeader_logo__-Bn+E"};